import { AbstractControl, ValidationErrors } from "@angular/forms";
import { PATTERNs } from "src/app/app-data";

export class CustomValidator {

    static validatePassword(control: AbstractControl) {
        if (control.value == '' || control.value == null) return null;
        let val = (control.value) ? control.value : window.event;
        var filter = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&+"#')(,-./])[A-Za-z\d@$!%*?&+"#')(,-./]{10,}$/;
        if (!filter.test(val)) {
            return { isValidated: true };
        }
        return null;
    }
    static passwordConfirmPasswordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {

        const newPassword = control.get('newPassword');
        const confirmPassword = control.get('confirmPassword');

        // Ensure both controls exist and compare their values

        if (newPassword && confirmPassword && newPassword.value !== confirmPassword.value) {
            return { 'passwordMismatch': true };
        }

        return null;
    }
    static validateEmail(control: AbstractControl) {
        if (control.value == '' || control.value == null) return null;
        let val = (control.value) ? control.value : window.event;
        var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!filter.test(val)) {
            return { isValidated: true };
        }
        return null;
    }
    // Alphanumeric with spaces (no special characters)
    static alphanumericWithSpaces(control: AbstractControl): ValidationErrors | null {
        const alphanumericWithSpacesRegex = /^[a-zA-Z0-9 ]+$/; // Alphanumeric with spaces allowed

        if (control.value && !alphanumericWithSpacesRegex.test(control.value)) {
            return { alphanumericWithSpaces: true }; // Return error if validation fails
        }
        return null; // Return null if validation passes
    }
    // Alphanumeric with no spaces (no special characters)
    static alphanumericNoSpaces(control: AbstractControl): ValidationErrors | null {
        const alphanumericNoSpaceRegex = /^[a-zA-Z0-9]+$/;
        if (control.value && !alphanumericNoSpaceRegex.test(control.value)) {
            return { alphanumericNoSpaces: true };
        }
        return null; // Return null if validation passes
    }

    // Alphanumeric with special character with no spaces
    static alphanumericWithSpecialChar(control: AbstractControl): ValidationErrors | null {
        if (control.value && !(PATTERNs.password).test(control.value)) {
            return { alphanumericWithSpecialChar: true };
        }
        return null;
    }

    // Allow alphanumeric characters, case insensitive
    static alphanumericNoCaseSensitive(control: AbstractControl): ValidationErrors | null {
        const alphanumericRegex = /^[a-zA-Z0-9]+$/i;

        if (control.value && !alphanumericRegex.test(control.value)) {
            return { alphanumericNoCaseSensitive: true };
        }
        return null;
    }
    // Allow only numbers
    static numbersOnly(control: AbstractControl): ValidationErrors | null {
        const numbersOnlyRegex = /^[0-9]+$/;

        if (control.value && !numbersOnlyRegex.test(control.value)) {
            return { numbersOnly: true };
        }
        return null;
    }


    // Error Messages
    static LoginErrorMessages = {
        username: {
            "required": "Username is required.",
            "minlength": "Username must be at least 5 characters.",
            "maxlength": "Username must be maximum of 32 characters.",
            "alphanumericNoSpaces": 'Username must contain only letters and numbers with no spaces'
        },
        password: {
            "required": "Password is required.",
            "minlength": "Password must be at least 10 characters.",
            "maxlength": "Password must be maximum of 20 characters.",
            "isValidated": "Password must be minimum of 10 characters, at least 1 Upper case, 1 Lower case, 1 Number & 1 Special character.",
            "alphanumericWithSpecialChar": "Password must contain at least 1 uppercase, 1 lowercase, 1 number and 1 special character without spaces."
        }
    }
    static ResetErrorMessages = {
        email: {
            "required": "Email is required.",
            "isValidated": "Please provide a valid email."
        },
        newPassword: {
            "required": "Password is required.",
            "minlength": "Password must be at least 10 characters.",
            "maxlength": "Password must be maximum of 20 characters.",
            "isValidated": "Password must be minimum of 10 characters, at least 1 uppercase, 1 lowercase, 1 number & 1 Special character.",
            "alphanumericWithSpecialChar": "Password must contain at least 1 uppercase, 1 lowercase, 1 number and 1 special character without spaces."
        },
        confirmPassword: {
            "required": "Confirm Password is required.",
            "minlength": "Confirm Password must be at least 10 characters.",
            "maxlength": "Confirm Password must be maximum of 20 characters."
        }
    }
    static CreateCampaignErrorMessages = {
        username: {
            "required": "Campaign Name is required.",
            "minlength": "Campaign Name must be at least 6 characters.",
            "maxlength": "Campaign Name must be maximum of 12 characters.",
            "alphanumericWithSpaces": "Campaign Name must contain only letters and numbers."
        },
        descriptions: {
            "minlength": "Descriptions must be at least 5 characters.",
            "maxlength": "Descriptions must be maximum of 256 characters."
        },
        startDate: {
        },
        endDate: {
        },
    }
    static CreateFranchiseErrorMessages = {
        franchise_name: {
            "required": "Franchise Name is required.",
            "minlength": "Franchise Name must be at least 5 characters.",
            "maxlength": "Franchise Name must be maximum of 64 characters.",
            "isValidated": 'Franchise Name should not contain special characters.',
            "alphanumericWithSpaces": 'Franchise Name must contain only letters and numbers.'
        }
    }
    static CreateStoreErrorMessages = {
        StoreID: {
            "required": "Store ID is required.",
            "maxlength": "Store ID must be maximum of 8 numbers.",
            "numbersOnly": "Store ID must be numbers only."
        },
        StoreName: {
            "required": "Store Name is required.",
            "minlength": "Store Name must be at least 2 characters.",
            "maxlength": "Store Name must be maximum of 64 characters.",
            // "alphanumericNoCaseSensitive": "Only alphanumeric characters are allowed, and case is not sensitive."
        },
        franchise: {
            "required": "Franchise is required."
        },
        billingGroup: {
            "required": "Billing Group is required."

        }
    }
    static CreateBillingGrpErrorMessages = {
        billingGroupName: {
            "required": "Billing Group Name is required.",
            // "minlength": "Billing Group Name must be at least 1 characters.",
            "maxlength": "Billing Group Name must be maximum of 255 characters.",
            "alphanumericWithSpaces": "Billing Group Name must contain only letters and numbers."
        },
        franchise: {
            "required": "Franchise is required."
        }
    }
    static CreateUserErrorMessages = {
        username: {
            "required": "Username is required.",
            "minlength": "Username must be at least 5 characters.",
            "maxlength": "Username must be maximum of 32 characters.",
            "alphanumericNoSpaces": 'Username must contain only letters and numbers with no spaces.'
        },
        email: {
            "required": "Email is required.",
            "isValidated": "Please provide a valid email."
        },
        franchise: {
            "required": "Franchise is required."
        },
        role: {
            "required": "Role is required."
        }
    }
    static ReportErrorMessages = {
        franchise: {
            "required": "Franchisee is required.",
        },
        report: {
            "required": "Report is required.",
        },
        campaign: {
            "required": "Campaign is required."
        }
    }

}




// }